import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock, Banknote, X, Search } from 'lucide-react';
// Track analytics events (similar to ServiceCategories)
const trackEvent = (eventName: string, eventData: any) => {
  console.log(`Analytics Event: ${eventName}`, eventData);
  // In a real app, this would call your analytics service
  const events = JSON.parse(sessionStorage.getItem('analyticsEvents') || '[]');
  events.push({
    eventName,
    eventData,
    timestamp: new Date().toISOString()
  });
  sessionStorage.setItem('analyticsEvents', JSON.stringify(events));
};
export const PopularServices = () => {
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const handleViewAllClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowModal(true);
    // Track the event
    trackEvent('view_all_services_clicked', {
      source: 'popular_services_section',
      timestamp: new Date().toISOString()
    });
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setSearchTerm('');
  };
  const handleServiceClick = (service: any) => {
    // Track the event
    trackEvent('service_selected', {
      service: service.title,
      link: service.link,
      source: 'all_services_modal',
      timestamp: new Date().toISOString()
    });
    setShowModal(false);
  };
  const services = [{
    id: 1,
    title: 'National ID Application',
    description: 'Apply for a new national ID or replace a lost one',
    category: 'Citizen',
    fee: 'Free',
    processingTime: '5-7 business days',
    link: '/services/national-id'
  }, {
    id: 2,
    title: 'Business Registration',
    description: 'Register your new business or company',
    category: 'Business',
    fee: '$30.00',
    processingTime: '2-3 business days',
    link: '/services/business-registration'
  }, {
    id: 3,
    title: 'Passport Application',
    description: 'Apply for a new passport or renew existing one',
    category: 'Immigration',
    fee: '$50.00',
    processingTime: '10-15 business days',
    link: '/services/passport'
  }, {
    id: 4,
    title: 'Birth Certificate',
    description: 'Request a birth certificate for yourself or your child',
    category: 'Document',
    fee: '$5.00',
    processingTime: '1-2 business days',
    link: '/services/birth-certificate'
  }, {
    id: 5,
    title: "Driver's License",
    description: "Apply for a new driver's license or renew an existing one.",
    category: 'Transport',
    fee: '$25.00',
    processingTime: '3-5 business days',
    link: '/services/drivers-license'
  }, {
    id: 6,
    title: 'Marriage Registration',
    description: 'Register your marriage and get a certificate',
    category: 'Civil',
    fee: '$15.00',
    processingTime: '1-2 business days',
    link: '/services/marriage-registration'
  },
  // Additional services for the modal
  {
    id: 7,
    title: 'Tax Filing',
    description: 'File your annual tax returns online',
    category: 'Taxation',
    fee: 'Free',
    processingTime: 'Immediate',
    link: '/services/tax-filing'
  }, {
    id: 8,
    title: 'Vehicle Registration',
    description: 'Register a new vehicle or transfer ownership',
    category: 'Transport',
    fee: '$35.00',
    processingTime: '2-4 business days',
    link: '/services/vehicle-registration'
  }, {
    id: 9,
    title: 'Land Title Search',
    description: 'Search for land ownership records',
    category: 'Property',
    fee: '$10.00',
    processingTime: '1-3 business days',
    link: '/services/land-title-search'
  }, {
    id: 10,
    title: 'Business License Renewal',
    description: 'Renew your existing business license',
    category: 'Business',
    fee: '$20.00',
    processingTime: '1-2 business days',
    link: '/services/business-license-renewal'
  }, {
    id: 11,
    title: 'Work Permit',
    description: 'Apply for a work permit for foreign nationals',
    category: 'Immigration',
    fee: '$75.00',
    processingTime: '10-20 business days',
    link: '/services/work-permit'
  }, {
    id: 12,
    title: 'Police Clearance',
    description: 'Get a police clearance certificate',
    category: 'Security',
    fee: '$15.00',
    processingTime: '3-5 business days',
    link: '/services/police-clearance'
  }];
  // Filter services based on search term for the modal
  const filteredServices = services.filter(service => service.title.toLowerCase().includes(searchTerm.toLowerCase()) || service.category.toLowerCase().includes(searchTerm.toLowerCase()) || service.description.toLowerCase().includes(searchTerm.toLowerCase()));
  return <section className="py-16 bg-gray-50" data-id="element-87">
      <div className="container mx-auto px-4" data-id="element-88">
        <div className="flex justify-between items-center mb-10" data-id="element-89">
          <div data-id="element-90">
            <h2 className="text-3xl font-bold mb-2" data-id="element-91">Popular Services</h2>
            <p className="text-gray-600" data-id="element-92">
              Most frequently used government services
            </p>
          </div>
          <a href="#" onClick={handleViewAllClick} className="flex items-center text-blue-600 font-medium hover:text-blue-800" data-id="element-93">
            View all services
            <ArrowRight className="ml-2 h-4 w-4" data-id="element-94" />
          </a>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-95">
          {services.slice(0, 6).map(service => <div key={service.id} className="bg-white rounded-lg overflow-hidden shadow-sm border hover:shadow-md transition-shadow" data-id="element-96">
              <div className="p-6" data-id="element-97">
                <div className="inline-block px-3 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded-full mb-4" data-id="element-98">
                  {service.category}
                </div>
                <h3 className="text-xl font-semibold mb-2" data-id="element-99">{service.title}</h3>
                <p className="text-gray-600 mb-4" data-id="element-100">{service.description}</p>
                <div className="flex items-center gap-6 text-sm text-gray-600 mb-4" data-id="element-101">
                  <div className="flex items-center" data-id="element-102">
                    <Clock className="h-4 w-4 mr-2 text-purple-600" data-id="element-103" />
                    <span data-id="element-104">{service.processingTime}</span>
                  </div>
                  <div className="flex items-center" data-id="element-105">
                    <Banknote className="h-4 w-4 mr-2 text-amber-600" data-id="element-106" />
                    <span data-id="element-107">{service.fee}</span>
                  </div>
                </div>
                <Link to={service.link} className="block w-full text-center bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md transition-colors" data-id="element-108">
                  Apply Now
                </Link>
              </div>
            </div>)}
        </div>
      </div>
      {/* All Services Modal */}
      {showModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-109">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto" data-id="element-110">
            <div className="p-6" data-id="element-111">
              <div className="flex justify-between items-center mb-6" data-id="element-112">
                <h2 className="text-2xl font-bold" data-id="element-113">All Government Services</h2>
                <button onClick={handleCloseModal} className="text-gray-500 hover:text-gray-700" data-id="element-114">
                  <X className="h-6 w-6" data-id="element-115" />
                </button>
              </div>
              {/* Search box */}
              <div className="relative mb-6" data-id="element-116">
                <input type="text" placeholder="Search services by name, category or description..." className="w-full pl-10 pr-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-117" />
                <Search className="absolute left-3 top-3.5 h-5 w-5 text-gray-400" data-id="element-118" />
              </div>
              {/* Categories summary */}
              <div className="flex flex-wrap gap-2 mb-6" data-id="element-119">
                {Array.from(new Set(services.map(service => service.category))).map(category => <button key={category} className="px-3 py-1 bg-blue-100 text-blue-800 text-sm font-medium rounded-full hover:bg-blue-200" onClick={() => setSearchTerm(category)} data-id="element-120">
                    {category}
                  </button>)}
                {searchTerm && <button className="px-3 py-1 bg-gray-200 text-gray-700 text-sm font-medium rounded-full hover:bg-gray-300" onClick={() => setSearchTerm('')} data-id="element-121">
                    Clear filter
                  </button>}
              </div>
              {/* Services grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-122">
                {filteredServices.map(service => <Link key={service.id} to={service.link} className="bg-white rounded-lg overflow-hidden shadow-sm border hover:shadow-md hover:border-blue-300 transition-all p-4" onClick={() => handleServiceClick(service)} data-id="element-123">
                    <div className="inline-block px-3 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded-full mb-3" data-id="element-124">
                      {service.category}
                    </div>
                    <h3 className="text-lg font-semibold mb-2" data-id="element-125">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 text-sm mb-3" data-id="element-126">
                      {service.description}
                    </p>
                    <div className="flex items-center gap-4 text-xs text-gray-600" data-id="element-127">
                      <div className="flex items-center" data-id="element-128">
                        <Clock className="h-3 w-3 mr-1 text-purple-600" data-id="element-129" />
                        <span data-id="element-130">{service.processingTime}</span>
                      </div>
                      <div className="flex items-center" data-id="element-131">
                        <Banknote className="h-3 w-3 mr-1 text-amber-600" data-id="element-132" />
                        <span data-id="element-133">{service.fee}</span>
                      </div>
                    </div>
                  </Link>)}
              </div>
              {filteredServices.length === 0 && <div className="text-center py-8" data-id="element-134">
                  <p className="text-gray-500" data-id="element-135">
                    No services found matching "{searchTerm}"
                  </p>
                  <button onClick={() => setSearchTerm('')} className="mt-2 text-blue-600 hover:text-blue-800" data-id="element-136">
                    Clear search
                  </button>
                </div>}
              <div className="mt-6 flex justify-end" data-id="element-137">
                <button onClick={handleCloseModal} className="px-8 py-2 bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-md transition-colors" data-id="element-138">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>}
    </section>;
};